export default "__VITE_ASSET__DspZvvuw__"